import type { ReceivedInvoiceReceiptType } from '@/context/services/invoice/type';
import {
  ElectronicTag,
  TimestampTag,
  type Status,
} from '@/features/InvoiceReport/Components/Tags';
import { DownloadButton } from '@/features/invoices/components/Details/Components/Left/DownloadButton';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { useReceiptTypeChecks } from '@/hooks/useReceiptTypeChecks';
import classNames from 'classnames';
import { FC, memo, useMemo } from 'react';
import styles from './PdfHeader.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  timestamp?: boolean;
  scanDecision?: Status;
  isEmpty?: boolean;
  receiptType?: ReceivedInvoiceReceiptType;
  isEnabledEDoc?: boolean;
  onDownloadClick?: () => void;
  isPeppolGateway?: boolean;
  fileName?: string;
  invoiceId?: string;
};

export const PdfHeader: FC<Props> = memo(
  ({
    timestamp,
    scanDecision,
    isEmpty,
    receiptType,
    isEnabledEDoc,
    onDownloadClick,
    isPeppolGateway,
    fileName,
    invoiceId,
  }) => {
    const { isPaperReceipt } = useReceiptTypeChecks(receiptType);
    const flagEdocMetadata = useGetFlags('E_DOC_METADATA');

    const isShowElectronicTag = useMemo(() => {
      if (scanDecision && !isEmpty && isPaperReceipt && isEnabledEDoc) {
        return true;
      }
      return false;
    }, [scanDecision, isEmpty, isPaperReceipt, isEnabledEDoc]);

    if (!timestamp && !isShowElectronicTag && !flagEdocMetadata) {
      return null;
    }

    return (
      <div
        className={cx(styles.container, {
          [styles['non-attachment']]: isEmpty,
        })}
      >
        <div className={styles['e-doc-container']}>
          {timestamp && flagEdocMetadata && <TimestampTag />}
          {isShowElectronicTag && flagEdocMetadata && (
            <ElectronicTag status={scanDecision!} />
          )}
        </div>
        {flagEdocMetadata && onDownloadClick && (
          <DownloadButton
            onDownloadClick={onDownloadClick}
            isPeppolGateway={isPeppolGateway}
            fileName={fileName}
            invoiceId={invoiceId}
          />
        )}
      </div>
    );
  }
);
PdfHeader.displayName = 'PdfHeader';
